// B3.1 — structured Firefly tour/ask request telemetry (mirror B2.4-B).

import type { ActivityDockAssistLevel } from "@/lib/activityDock/assistLevel";
import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import type {
  FireflyInputModality,
  FireflyPttTrigger,
  FireflyTourRequestEventDetail,
  FireflyTourRequestOutcome,
  FireflyTourTrigger,
} from "./tourTypes";
import type { FireflyIntent } from "@/components/activity/firefly/fireflyIntents";

export const FIREFLY_TOUR_REQUEST_EVENT = "bb-firefly-tour-request";

export function buildFireflyTourRequestEventDetail(input: {
  tourId?: string;
  queryText?: string;
  trigger: FireflyTourTrigger;
  intent: Extract<FireflyIntent, "teaching" | "discovery" | "guidance">;
  mode: PrimaryMode;
  targetMode?: PrimaryMode;
  outcome: FireflyTourRequestOutcome;
  assistLevel: ActivityDockAssistLevel;
  nowMs: number;
  inputModality?: FireflyInputModality;
  pttTrigger?: FireflyPttTrigger;
}): FireflyTourRequestEventDetail {
  return {
    tourId: input.tourId,
    queryText: input.queryText,
    trigger: input.trigger,
    intent: input.intent,
    mode: input.mode,
    targetMode: input.targetMode,
    outcome: input.outcome,
    assistLevel: input.assistLevel,
    ts: input.nowMs,
    ...(input.inputModality != null ? { inputModality: input.inputModality } : {}),
    ...(input.pttTrigger != null ? { pttTrigger: input.pttTrigger } : {}),
  };
}

export function emitFireflyTourRequestEvent(detail: FireflyTourRequestEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<FireflyTourRequestEventDetail>(FIREFLY_TOUR_REQUEST_EVENT, {
      detail,
    }),
  );
}
